import { Btn } from "./PetsButtonStyled";

export const PetsButton = ({ changePage }) => {
  return <Btn onClick={changePage}>See more</Btn>;
};
